import { FiasAddress } from "../../../Utils/FiasAddressUtils";
import { getHouseTypeLongName, getHouseTypeObjectID } from "../../../FiasInput/Utils/Convertations/House/House";
import { getFlatTypeLongName, getFlatTypeObjectID } from "../../../FiasInput/Utils/Convertations/Flat/Flat";
import { addClearOptionToArrayByExistItem } from "../FiasFnsManualEditor/FiasFnsManualEditorUtils";

export interface FiasMvdAddress {
    Region?: string;
    District?: string;
    City?: string;
    Settlement?: string;
    PlanningStructure?: string;
    Street?: string;
    House?: FiasMvdHouse;
    Housing?: FiasMvdHouse;
    Structure?: FiasMvdHouse;
    Flat?: FiasMvdFlat;
}

export interface FiasMvdHouse {
    Type?: string;
    Number?: string;
}

export interface FiasMvdFlat {
    Type?: string;
    Number?: string;
}

export function extractMvdAddressFromModel(value: FiasAddress) {
    const mvdFiasAddress: FiasMvdAddress = {};
    const addressObjectStringTokens = value["addressObjectString"]?.replaceAll(", ", "$").split("$") ?? [];
    mvdFiasAddress.Region = addressObjectStringTokens[0] ?? undefined;
    mvdFiasAddress.District = addressObjectStringTokens[1] ?? undefined;
    mvdFiasAddress.City = addressObjectStringTokens[2] ?? undefined;
    mvdFiasAddress.Settlement = addressObjectStringTokens[3] ?? undefined;
    mvdFiasAddress.PlanningStructure = addressObjectStringTokens[4] ?? undefined;
    mvdFiasAddress.Street = addressObjectStringTokens[5] ?? undefined;

    mvdFiasAddress.House = {
        Number: value["housing/0/value"] ?? undefined,
        Type: value["housing/0/type/value"] ?? undefined,
    };
    mvdFiasAddress.Housing = {
        Number: value["housing/1/value"] ?? undefined,
        Type: value["housing/1/type/value"] ?? undefined,
    };
    mvdFiasAddress.Structure = {
        Number: value["housing/2/value"] ?? undefined,
        Type: value["housing/2/type/value"] ?? undefined,
    };
    mvdFiasAddress.Flat = {
        Number: value["housing/3/value"] ?? undefined,
        Type: value["housing/3/type/value"] ?? undefined,
    };
    return mvdFiasAddress;
}

function setHousingAtIndex(mvdFiasAddress: FiasMvdAddress, index: number, modelAddress: FiasAddress) {
    const element = index == 0 ? "House" : index == 1 ? "Housing" : index == 2 ? "Structure" : "Flat";
    modelAddress[`housing/${index}/type/type`] = "addressObjectType";
    if (index === 3) {
        modelAddress[`housing/${index}/type/element`] = getFlatTypeObjectID(mvdFiasAddress[element]?.Type) ?? "";
        modelAddress[`housing/${index}/type/value`] = getFlatTypeLongName(mvdFiasAddress[element]?.Type) ?? "";
    } else {
        modelAddress[`housing/${index}/type/element`] = getHouseTypeObjectID(mvdFiasAddress[element]?.Type) ?? "";
        modelAddress[`housing/${index}/type/value`] = getHouseTypeLongName(mvdFiasAddress[element]?.Type) ?? "";
    }
    modelAddress[`housing/${index}/value`] = mvdFiasAddress[element]?.Number ?? "";
}

export function formatFiasMvdAddressToModel(mvdFiasAddress: FiasMvdAddress): FiasAddress {
    const modelAddress: FiasAddress = {};
    const addressObjectString: undefined | string = [
        mvdFiasAddress.Region ?? "",
        mvdFiasAddress.District ?? "",
        mvdFiasAddress.City ?? "",
        mvdFiasAddress.Settlement ?? "",
        mvdFiasAddress.PlanningStructure ?? "",
        mvdFiasAddress.Street ?? "",
    ]
        .reduce((acc, address, index, array) => {
            if (index + 1 === array.length) {
                return address ? `${acc}${address}` : `${acc}`;
            }
            return address ? `${acc}${address}, ` : `${acc}$`;
        }, "")
        .replace(/(,\s)(\$*$)/, (_, __, p2) => `$${p2}`);

    modelAddress["addressObjectString"] = addressObjectString === "$$$$$" ? "" : addressObjectString;

    if (mvdFiasAddress.House?.Type || mvdFiasAddress.House?.Number) {
        setHousingAtIndex(mvdFiasAddress, 0, modelAddress);
    }
    if (mvdFiasAddress.Housing?.Type || mvdFiasAddress.Housing?.Number) {
        setHousingAtIndex(mvdFiasAddress, 1, modelAddress);
    }
    if (mvdFiasAddress.Structure?.Type || mvdFiasAddress.Structure?.Number) {
        setHousingAtIndex(mvdFiasAddress, 2, modelAddress);
    }
    if (mvdFiasAddress.Flat?.Type || mvdFiasAddress.Flat?.Number) {
        setHousingAtIndex(mvdFiasAddress, 3, modelAddress);
    }

    return modelAddress;
}

export const getMvdBuildingItems = (type: string | undefined) =>
    addClearOptionToArrayByExistItem(
        [
            ["Владение", "Владение - влд."],
            ["Дом", "Дом	- д."],
            ["Домовладение", "Домовладение - двлд."],
            ["Гараж", "Гараж - г-ж"],
            ["Здание", "Здание - зд."],
            ["Шахта", "Шахта - шахта"],
            ["Строение", "Строение - стр."],
            ["Сооружение", "Сооружение - соор."],
            ["Литера", "Литера - литера"],
            ["Корпус", "Корпус - к."],
            ["Подвал", "Подвал - подв."],
            ["Котельная", "Котельная - кот."],
            ["Погреб", "Погреб - пб."],
            ["Участок", "Земельный Участок - з/у"],
            ["Объект нез-го стр-ва", "Объект нез-го стр-ва - ОНС"],
        ],
        type
    );
